import { render, staticRenderFns } from "./CourseListBj.vue?vue&type=template&id=2e8c598e"
import script from "./CourseListBj.vue?vue&type=script&lang=js"
export * from "./CourseListBj.vue?vue&type=script&lang=js"
import style0 from "./CourseListBj.vue?vue&type=style&index=0&id=2e8c598e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports